import "./styles.css";

export function ContentCardRoot({
  children,
  titleLink,
  height = "110px",
  width = "100%"
}) {
  return (
    <a
      href={titleLink}
      target="_blank"
      rel="noreferrer"
      style={{ minHeight: height, maxWidth: width, width }}
      className="d-flex flex-row card--link align-items-stretch justify-content-start overflow-hidden rounded-sm mt-3 mb-0 w-100 card"
    >
      {children}
    </a>
  );
}
